import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ExamTemplate } from '../../exam-template/exam-template';
import { ExamRequest } from '../../exam/exam-request';

declare var jQuery: any;

@Component({
  selector: 'mc-exam-form',
  templateUrl: './exam-form.component.html',
  styleUrls: ['./exam-form.component.scss']
})
export class ExamFormComponent {

  @ViewChild('createNewModal', { static: true }) private createNewModal: ElementRef;
  @Input() detached: boolean;
  @Input() examRequest: ExamRequest;
  @Output() canceled: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saved: EventEmitter<ExamTemplate> = new EventEmitter<ExamTemplate>();

  constructor(private notifService: ToastrService) {}

  cancel(): void {
    this.canceled.emit(true);
  }

  save(): void {
    this.saved.emit(this.examRequest);
  }

  searchExamTemplate(): void {
    jQuery(this.createNewModal.nativeElement).modal('show');
  }

  selectedTemplate(template: ExamTemplate): void {
    if (!template) { return; }

    const existingTemplate = this.examRequest.exam_templates.find(element => element.id === template.id);
    if (existingTemplate) {
      this.notifService.info('Procedimento já adicionado');
      return;
    }

    this.examRequest.exam_templates.push(template);
  }

  hasExams(): boolean {
    return this.examRequest && this.examRequest.exam_templates && this.examRequest.exam_templates.length > 0;
  }
}
